import { AgentIntegrationsChatbot } from '@/modules/gpt-chats/components/agent-integrations/agent-integrations-chatbot';

type AgentIntegrationHubProps = {
  id: string;
};

export const AgentIntegrationHub = ({ id }: AgentIntegrationHubProps) => {
  return (
    <>
      <div>
        <div className="h-[500px]">
          <AgentIntegrationsChatbot agentId={id} />
        </div>
        {/* <Tabs value={tabQueryState} onValueChange={setTabQueryState}>
          <TabsList>
            <TabsTrigger value="chat-bot">Chatbot</TabsTrigger>
            <TabsTrigger value="stand-alone">Standalone</TabsTrigger>
            <TabsTrigger value="voice">Voice</TabsTrigger>
          </TabsList>
          <div className="mt-4">
            <TabsContent value="chat-bot">
              <div className="h-[500px]">
                <AgentIntegrationsChatbot agentId={id} />
              </div>
            </TabsContent>
            <TabsContent value="stand-alone">
              <div className="h-[500px]">
                <ComingSoonPage message="Coming soon" />
              </div>
            </TabsContent>
            <TabsContent value="voice">
              <div className="h-[500px]">
                <ComingSoonPage message="Coming soon" />
              </div>
            </TabsContent>
          </div>
        </Tabs> */}
      </div>
    </>
  );
};
